import { Skeleton } from '@/components/ui/skeleton';

const SKELETON_ROW_COUNT = 3;

export const VendorRequestsListSkeleton = () => (
  <div className="flex flex-col gap-4">
    {Array.from({ length: SKELETON_ROW_COUNT }).map((_, index) => (
      <div key={index} data-testid="request-card-skeleton" className="rounded-xl border border-border p-5">
        <Skeleton className="h-5 w-1/3 mb-3" />
        <Skeleton className="h-4 w-2/3 mb-4" />
        <Skeleton className="h-20 w-full" />
      </div>
    ))}
  </div>
);
